import React from 'react';
import { Button, ButtonTemplateProps, ButtonVariant } from '..';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';

interface SaveButtonProps extends ButtonTemplateProps {}

export default function SaveButton(props: SaveButtonProps) {
  return <Button {...props} text={t(TranslationKey.save).singular.upper} variant={ButtonVariant.primary} />;
}
